import React from 'react'
import TemplateWrapper from './src/components/Layout'

// wrap the root element in the global state context provider
export const wrapRootElement = ({ element, props }) => {
  return <TemplateWrapper {...props}>{element}</TemplateWrapper>
}
